export const  activirtyHours = [{
    title: "Time Spent",
    inNumber: "30",
    inPercentage: "140%"
},
{
    title: "Lessons taken",
    inNumber: "45",
    inPercentage: "86%"
},
{
    title: "Exams passed",
    inNumber: "12",
    inPercentage: "120%"
}
]

export const  courses =[{
    iconWrap: require("@/assets/images/dashboard-3/course/1.svg"),
    backArrow: require("@/assets/images/dashboard-3/course/back-arrow/1.png"),
    title: "Management"
},
{
    iconWrap: require("@/assets/images/dashboard-3/course/2.svg"),
    backArrow: require("@/assets/images/dashboard-3/course/back-arrow/2.png"),
    title: "Web Devlopment"
},
{
    iconWrap: require("@/assets/images/dashboard-3/course/3.svg"),
    backArrow: require("@/assets/images/dashboard-3/course/back-arrow/1.png"),
    title: "Business Analytics"
},
{
    iconWrap: require("@/assets/images/dashboard-3/course/4.svg"),
    backArrow: require("@/assets/images/dashboard-3/course/back-arrow/3.png"),
    title: "Marketing"
}
]

export const  upcomingSchedule =[{
    iconWrap: require("@/assets/images/dashboard-3/course/1.svg"),
    backArrow: require("@/assets/images/dashboard-3/course/back-arrow/1.png"),
    title: "Management"
},
{
    iconWrap: require("@/assets/images/dashboard-3/course/2.svg"),
    backArrow: require("@/assets/images/dashboard-3/course/back-arrow/2.png"),
    title: "Web Devlopment"
},
{
    iconWrap: require("@/assets/images/dashboard-3/course/3.svg"),
    backArrow: require("@/assets/images/dashboard-3/course/back-arrow/1.png"),
    title: "Business Analytics"
},
{
    iconWrap: require("@/assets/images/dashboard-3/course/4.svg"),
    backArrow: require("@/assets/images/dashboard-3/course/back-arrow/3.png"),
    title: "Marketing"
}
]